import React, { useContext, useCallback } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PATH_ACCOUNT_SETUP, PATH_DASHBOARD, PATH_EMP_ACCOUNT_LINKAGE, PATH_EMP_MEMBER_SETUP, PATH_HOME } from '../../system/constants';
import { AppContext } from '../contexts';
import { BASE_URL, DASHBOARD_ID_MY_SETTINGS, ROUTE_TYPE_EMP, ROUTE_TYPE_JS, USER_TYPE_EMP, USER_TYPE_JS } from '../constants';
import _get from 'lodash/get';
import AuthHandlerLayout from '../../authHandler/AuthHandlerLayout';
// import DashboardLayout from '../../dashboard/DashboardLayout';
// import EmpDashboardLayout from '../../empDashboard/DashboardLayout';
// import EmpAccountSetupLayout from '../../empDashboard/AccountSetupLayout';
import EmpAccountLinkageLayout from '../../empAccountLinkage/EmpAccountLinkageLayout';
import MemberSetupLayout from '../../empDashboard/MemberSetupLayout';
import BlockJsLayout from '../../auth/BlockJsLayout';
import BlockEmpLayout from '../../auth/BlockEmpLayout';
import CreateAccountLayout from '../../auth/CreateAccountLayout';

const AfitdPrivateRoute = props => {
    const appContext = useContext(AppContext);
    // const auth = _get(appContext, 'auth');
    const { authUser, emailVerified, authTypeEmail, pendingAccountSetup, pendingEmpAccountLinkage, pendingMemberSetup, currentUser, userId, userDocExist, authRedirectResult } =
        appContext;

    const isEmp = _get(currentUser, 'type') === USER_TYPE_EMP;
    const isJs = _get(currentUser, 'type') === USER_TYPE_JS;

    const isNewUser = authRedirectResult?.additionalUserInfo?.isNewUser;

    const { component: RouteComponent, children, type: routeType, ...rest } = props;

    const getRouteRender = useCallback(
        routeProps => {
            const redirectPathname = _get(routeProps, 'location.pathname', `${BASE_URL}/`);
            const isAccountSetupPage = redirectPathname === `${BASE_URL}${PATH_ACCOUNT_SETUP}`;
            const isEmpLinkagePage = redirectPathname === `${BASE_URL}${PATH_EMP_ACCOUNT_LINKAGE}`;
            const isEmpMemberSetupPage = redirectPathname === `${BASE_URL}${PATH_EMP_MEMBER_SETUP}`;
            if ((isNewUser || userId) && !userDocExist) {
                return <CreateAccountLayout />;
            } else if (authUser) {
                if (emailVerified || !authTypeEmail) {
                    if (currentUser) {
                        // if user access the wrong page
                        if (routeType === ROUTE_TYPE_EMP && isJs) {
                            return <BlockJsLayout />;
                        } else if (routeType === ROUTE_TYPE_JS && isEmp) {
                            return <BlockEmpLayout />;
                        }

                        // user created the account with an invitation, redirect to Emp Account Linkage
                        if (pendingEmpAccountLinkage && isEmp) {
                            // do not redirect again if path is PATH_EMP_ACCOUNT_LINKAGE
                            if (isEmpLinkagePage) {
                                return <EmpAccountLinkageLayout />;
                            } else {
                                return <Redirect to={{ pathname: `${BASE_URL}${PATH_EMP_ACCOUNT_LINKAGE}`, push: true }} />;
                            }
                        } else if (pendingMemberSetup && isEmp) {
                            // do not redirect again if path is PATH_EMP_MEMBER_SETUP
                            if (isEmpMemberSetupPage) {
                                return <MemberSetupLayout />;
                            } else {
                                return <Redirect to={{ pathname: `${BASE_URL}${PATH_EMP_MEMBER_SETUP}`, push: true }} />;
                            }
                        } else if (isEmpMemberSetupPage && !pendingMemberSetup && isEmp) {
                            // if path is member setup page but account status NOT PMS, redirect to Dashboard
                            return <Redirect to={{ pathname: `${BASE_URL}${PATH_DASHBOARD}`, push: true }} />;
                        } else if (isAccountSetupPage && !pendingAccountSetup) {
                            return <Redirect to={{ pathname: `${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`, push: true }} />;
                        } else if (pendingAccountSetup && !isEmpLinkagePage) {
                            // user has not completed the account set up, redirect to Dashboard
                            // return isEmp ? <EmpAccountSetupLayout /> : <DashboardLayout />;
                            if (isEmp) {
                                return <Redirect to={{ pathname: `${BASE_URL}${PATH_ACCOUNT_SETUP}`, push: false }} />;
                            } else if (isJs) {
                                return <Redirect to={{ pathname: `${BASE_URL}${PATH_DASHBOARD}`, push: false }} />;
                            } else {
                                return null;
                            }
                        } else {
                            // authenticated! Proceed.
                            return children;
                        }
                    } else {
                        return null;
                    }
                } else {
                    // pre-verified. Redirect to 'verify email' page.
                    return <AuthHandlerLayout showVerificationEmailSent />;
                }
            } else {
                // set the original path in the router location state with a flag telling it to show the login dialog
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_HOME}`, state: { redirectPathname, isPromptLogin: true }, push: true }} />;
            }
        },
        [
            authUser,
            currentUser,
            children,
            emailVerified,
            authTypeEmail,
            isEmp,
            isJs,
            routeType,
            pendingAccountSetup,
            pendingEmpAccountLinkage,
            pendingMemberSetup,
            isNewUser,
            userId,
            userDocExist,
        ],
    );

    return <Route {...rest} render={getRouteRender} />;
};

export default AfitdPrivateRoute;
